import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { ApiEnvelope } from './super-admin-auth.service';

export interface SmtpSettingsData {
  use_custom_smtp: boolean;
  from_email: string;
  host: string;
  port: string;
  secure: boolean;
  auth_user: string;
  password_configured: boolean;
}

export interface UpdateSmtpSettingsBody {
  use_custom_smtp: boolean;
  from_email?: string;
  host?: string;
  port?: number;
  secure?: boolean;
  auth_user?: string;
  /** Omit or empty string keeps the stored password. */
  auth_password?: string;
}

@Injectable({ providedIn: 'root' })
export class SettingsApiService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl.replace(/\/$/, '');

  getSmtpSettings(): Observable<ApiEnvelope<SmtpSettingsData>> {
    return this.http.get<ApiEnvelope<SmtpSettingsData>>(`${this.base}/settings/smtp`);
  }

  patchSmtpSettings(body: UpdateSmtpSettingsBody): Observable<ApiEnvelope<SmtpSettingsData>> {
    return this.http.patch<ApiEnvelope<SmtpSettingsData>>(`${this.base}/settings/smtp`, body);
  }
}
